// @flow

import { PrivateStateAccessor } from '@ta/common.state';

/**
 * Set up a private redux slice for storing the PhotoCarousel state
 * */

export type CarouselState = {|
  currentIndex: number,
  hasWrapped: boolean,
|};

export type CarouselsState = {|
  [uniqueId: string]: CarouselState,
|};

const KEY = 'photo-carousel';
const DEFAULT_CAROUSELS_STATE = {};

const STATE_ACCESS: PrivateStateAccessor<$Shape<CarouselsState>> = new PrivateStateAccessor(
  KEY,
  DEFAULT_CAROUSELS_STATE,
);

// Export the method that fetches the state.
// This should be the only way to extract your private state from the
// Global state.  You can incorporate information from the rest of the
// global state into the private state you expose here, for example
// if you want to invalidate some fields when dates change
export const getState = (state: any) => STATE_ACCESS.getFrom(state);

export type PhotoCarouselActions = {|
  registerState: (uniqueId: string, newIndex: number, hasWrapped: boolean) => any,
|};

const ACTION_REGISTER_STATE = 'registerState';

export const ACTIONS: PhotoCarouselActions = {
  registerState: (uniqueId: string, newIndex: number, hasWrapped: boolean) =>
    STATE_ACCESS.action({
      type: ACTION_REGISTER_STATE,
      uniqueId,
      newIndex,
      hasWrapped,
    }),
};

// Set the reducer for the private slice. You can only call this once.
// The reducer is just like one you'd use with combineReducers()
STATE_ACCESS.setReducer(
  (prevState: $Shape<CarouselsState> = DEFAULT_CAROUSELS_STATE, action: any) => {
    // console.log("carousel action fired");
    switch (action.type) {
      case ACTION_REGISTER_STATE: {
        // console.log("carousel register state:", action.uniqueId);
        const carouselId = action.uniqueId;
        const newCarouselState = {
          currentIndex: action.newIndex,
          hasWrapped: action.hasWrapped,
        };
        const newState = { ...prevState };
        newState[carouselId] = newCarouselState;
        return newState;
      }
      default:
        return prevState;
    }
  },
);
